import NextHead from 'next/head'
import React from 'react'
import { assetUrl, buildVNWUrlFromPath } from '../helpers/urlBuilder'

const GTM_ID = process.env.GOOGLE_TAG_MANAGER_ID || ''
const favicon =
	`${process.env.VNW_BASE_URL}/favicon.ico?v=` + process.env.VNW_BUILD_ID
const gmtLink = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`

type THeadProps = {
	keywords: string
	title: string
	description: string
	ogImage: string
	url: string
	robot?: string
}

const Head = (props: THeadProps) => (
	<NextHead>
		<meta charSet='UTF-8' />
		<title>{props.title || ''}</title>
		<meta name='description' content={props.description} />
		<meta name='viewport' content='initial-scale=1.0, width=device-width' />
		<link rel='shortcut icon' href={favicon} type='image/x-icon' />
		<link rel='manifest' href={assetUrl('/static/manifest.json')} />
		<link
			rel='icon'
			sizes='192x192'
			href={assetUrl('/static/images/vnw_192.png')}
		/>
		<link
			rel='apple-touch-icon'
			href={assetUrl('/static/images/vnw_512.png')}
		/>

		<link
			rel='preload'
			as='image'
			href={buildVNWUrlFromPath(
				'/assets-page-container/images/feature-company-background.png'
			)}
		/>
		<meta name='theme-color' content='#005aff' />
		<meta
			name='robots'
			content={props.robot ? props.robot : 'index, follow'}
		/>
		<meta name='keywords' content={props.keywords} />
		<link rel='canonical' href={props.url} />
		<meta property='og:url' content={props.url} />
		<meta property='og:title' content={props.title || ''} />
		<meta property='og:description' content={props.description} />
		<meta name='twitter:site' content='@vietnamworks' />
		<meta name='twitter:card' content='summary' />
		<meta name='twitter:image' content={props.ogImage} />
		<meta property='og:image' content={props.ogImage} />
		<meta property='og:image:secure_url' content={props.ogImage} />
		<meta property='og:image:width' content='526' />
		<meta property='og:image:height' content='275' />
		<script async src={gmtLink} />
		<script
			async
			src={`${process.env.VNW_BASE_URL}/assets-page-container/js/jquery.min.js`}
		/>
	</NextHead>
)

export default Head
